<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      签名审核
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
          :class="{'search-detail-close': !searchVisible}"
          :style="{overflow: !searchVisible ? 'hidden' : ''}"
        >
        <div class="search-detail-item">
          <Select
            clearable
            filterable
            class="search-input"
            placeholder="请选择审核状态"
            v-model="searchForm.sms_audit_state"
          >
            <Option
              v-for="item in auditStateList"
              :key="item.value"
              :value="item.value+''"
            >{{item.name}}</Option>
          </Select>
        </div>
        <div class="search-detail-item">
          <Input
            class="search-input"
            placeholder="请输入签名名称"
            v-model="searchForm.sms_sign"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
            class="search-input"
            placeholder="请输入企业名称"
            v-model="searchForm.name"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Input
          class="search-input"
          placeholder="请输入corpID"
          v-model="searchForm.corpid"
          ></Input>
        </div>
        <div class="search-detail-item">
          <Button
            type="primary"
            class="search-button"
            @click="pageIndex=0,loadList()"
          >查找</Button>
          <Button
            class="search-button"
            @click="resetSearchForm"
          >重置</Button>
        </div>
        </div>
      </div>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
  </Card>
 </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker
  },
  data() {
    return {
      orderModalShow: false, // 购买弹窗
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      emptyDate: ['', ''],
      searchForm: {
        corpid: '',
        name: '',
        sms_sign: '',
        sms_audit_state: ''
      },
      packageNumber: [
        {
          value: '1',
          name: '报备中'
        },
        {
          value: '2',
          name: '免费版'
        },
        {
          value: '3',
          name: '试用版'
        },
        {
          value: '4',
          name: 'VIP版'
        },
        {
          value: '5',
          name: 'VIP到期'
        },
        {
          value: '6',
          name: '报备失败'
        }
      ],
      auditStateList: [
        {
          value: '1',
          name: '申请中'
        },
        {
          value: '2',
          name: '审核通过'
        },
        {
          value: '3',
          name: '审核拒绝'
        }
      ]
    }
  },
  computed: {
    ...mapState('table', ['columnsCheckedAll', 'pageSizeOpts']),
    // 表格列 根据选中的列动态生成
    columns() {
      const allColumns = [
        {
          title: '审核状态',
          key: 'sms_audit_state',
          width: 140,
          render: (h, { row }) => {
            if (row.sms_audit_state === 1) return '申请中'
            if (row.sms_audit_state === 2) return '审核通过'
            if (row.sms_audit_state === 3) return '审核拒绝'
            return ''
          }
        },
        {
          title: '短信签名名称',
          key: 'sms_sign',
          width: 140
        },
        {
          title: '企业名称',
          key: 'name',
          width: 140
        },
        {
          title: 'CorpID',
          key: 'corpid',
          ellipsis: true
        },
        {
          title: '联系人',
          key: 'link_person',
          width: 100
        },
        {
          title: '手机号码',
          key: 'link_msisdn',
          width: 140
        },
        {
          title: '套餐人数',
          key: 'package_name',
          width: 140
        },
        {
          title: '到期时间',
          key: 'service_expire_time',
          width: 160
        },
        {
          title: '操作',
          key: '',
          render: (h, { row }) => {
            const button = [
              h(
                'Button',
                {
                  props: {
                    type: 'primary'
                  },
                  nativeOn: {
                    click: () =>
                      this.review({ id: row.id, sms_audit_state: 2 })
                  },
                  style: {
                    marginRight: '10px'
                  }
                },
                '审核通过'
              ),
              h(
                'Button',
                {
                  nativeOn: {
                    click: () =>
                      this.review({ id: row.id, sms_audit_state: 3 })
                  }
                },
                '审核拒绝'
              )
            ]
            return h('div', row.sms_audit_state === 1 ? button : '')
          }
        }
      ]
      allColumns.forEach(v => (v.align = 'center'))
      return allColumns
    }
  },
  watch: {
    chouseState(val) {}
  },
  methods: {
    review(data) {
      this.$Modal.confirm({
        title: '审核',
        content: `确认审核${data.sms_audit_state === 2 ? '通过' : '拒绝'}吗？`,
        onOk: () => {
          this.$http
            .request({
              method: 'put',
              url: '/smsaudit/examine',
              data
            })
            .then(res => {
              if (res.success) {
                this.loadList()
                this.$Message.success('审核成功')
              } else {
                this.$Message.error('审核失败')
              }
            })
        }
      })
    },
    // 加载列表数据
    loadList() {
      this.listLoading = true
      this.$http
        .all([
          this.$http.get('/smsaudit/list', {
            params: {
              pageIndex: this.pageIndex,
              pageSize: this.pageSize,
              ...this.searchForm
            }
          }),

          this.$http.get('/smsaudit/count', {
            params: this.searchForm
          })
        ])
        .then(
          this.$http.spread((res1, res2) => {
            this.list = res1.data
            this.count = res2.data
            this.listLoading = false
          })
        )
    },
    // 分页 每页大小 改变回调
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange(pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 日期 改变回调
    daterangeChange(daterange, start, end) {
      if (daterange[0]) {
        this.searchForm[start] = daterange[0]
          .replace('/', '-')
          .replace('/', '-')
        this.searchForm[end] = daterange[1].replace('/', '-').replace('/', '-')
      } else {
        this.searchForm[start] = ''
        this.searchForm[end] = ''
      }
      this.emptyDate = [this.searchForm[start], this.searchForm[end]]
    },
    // 重置搜索框
    resetSearchForm() {
      this.chouseState = ''
      this.emptyDate = ['', '']
      this.searchForm = {
        corpid: '',
        name: '',
        sms_sign: '',
        sms_audit_state: ''
      }
      this.loadList()
    }
  },
  created() {
    // this.$http.get('/dropdown/industry').then(res => {
    //   this.busType = res.data
    // })
    // this.$http.get('/dropdown/chargePackage').then(res => {
    //   this.buyPeople = res.data
    // })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  margin-bottom: 16px;
  .search-top {
    display: flex;
    justify-content: space-between;

    .search-top-left {
      display: flex;
      width: 70%;

      .search-input {
        width: 80%;

        // margin-left: 10px;
      }

      .search-button {
        margin-left: 10px;
      }
    }

    .search-top-right {
      .filter-column {
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }

      .search-button {
        margin-left: 6px;
      }
    }
  }

  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
    height: 90px;
    transition: 0.5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n + 1),
    .search-detail-item:nth-child(4n + 2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/messageManage/signAudit/index.vue